module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.sass
// module id = ./src/app/app.component.sass
// module chunks = main